/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Withanswers1Inputs */

const zh_print_withanswers1 = /** @type {(inputs: Print_Withanswers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打印含答案`)
};

const en_print_withanswers1 = /** @type {(inputs: Print_Withanswers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print with Answers`)
};

const es_print_withanswers1 = /** @type {(inputs: Print_Withanswers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprimir con respuestas`)
};

/**
* | output |
* | --- |
* | "Print with Answers" |
*
* @param {Print_Withanswers1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const print_withanswers1 = /** @type {((inputs?: Print_Withanswers1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Withanswers1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_print_withanswers1(inputs)
	if (locale === "en") return en_print_withanswers1(inputs)
	return es_print_withanswers1(inputs)
});
export { print_withanswers1 as "print_withAnswers" }